import { useSearchParams } from 'react-router-dom'
import { useCallback, useEffect, useRef } from 'react'
import { startAutomatedDoraService } from '@/utils/helpers/automatedDoraService'

export const useAutomatedDora = () => {
  const [searchParams] = useSearchParams()
  const isFirstRender = useRef(true)

  const handleAutomatedDora = useCallback(() => {
    if (!isFirstRender.current) {
      return
    }

    startAutomatedDoraService(searchParams)
    isFirstRender.current = false
  }, [searchParams])

  useEffect(() => {
    handleAutomatedDora()
  }, [handleAutomatedDora])
}
